import {Model} from '@/engine';
import {Configuration} from '@/model/types';
import {createAccessMap, createDependencyMap} from '../dependencies';
import {createMigrations} from '../migrations';
import {ModelDocument} from '../types/model/document';
import {mapDocuments} from './documents';
import {replaceMetaVariables} from './meta';
import {mapToModelSection} from './section';
import {createValueDomain} from './values';

export async function createModel(configuration: Configuration): Promise<Model> {
  const conf = replaceMetaVariables(configuration);

  const values = await createValueDomain(conf.values);

  const dependencyMap = createDependencyMap();
  const accessMap = createAccessMap();

  const sections = conf.form.sections.map((section, index) => {
    accessMap.set(section.id, {sectionIndex: index});
    return mapToModelSection(section, values, dependencyMap, accessMap);
  });
  const documents: ModelDocument[] = mapDocuments(conf.form.documents, dependencyMap, accessMap);

  const model: Model = {
    version: conf.version,
    jsonVersion: conf.jsonVersion,
    form: {sections, documents},
    values,
    dependencyMap,
    accessMap,
    migrations: [],
  };

  return {...model, migrations: createMigrations(conf.migrations ?? [], model)};
}
